import React from 'react';
import { OnboardingStepGate } from '../../components/OnboardingStepGate';
import { ROUTES_PATH } from '../../constants/Routes';
import { useOnboardingOab } from './useOnboardingOab';

interface OnboardingOabGateProps {
  children: React.ReactNode;
  isExempt?: boolean;
}

export function OnboardingOabGate({ children, isExempt }: OnboardingOabGateProps) {
  const { status, isPollingCredits } = useOnboardingOab();

  return (
    <OnboardingStepGate
      status={status}
      stepPath={ROUTES_PATH.ONBOARDING.OAB}
      isPollingCredits={isPollingCredits}
      isExempt={isExempt}
    >
      {children}
    </OnboardingStepGate>
  );
}
